import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const ContactUsModal = ({ isOpen, closeModal }) => {
    const modalRef = useRef(null);
    const branch = useSelector((state) => state.myPage.branch);

    useEffect(() => {
        if (modalRef.current) {
            if (isOpen) {
                modalRef.current.showModal();
            } else {
                modalRef.current.close();
            }
        }
    }, [isOpen]);

    if (!branch) return null;

    return (
        <dialog ref={modalRef} className="contact-modal">
            <div className="contact-modal__header">
                <h4>{translate('code.products.modal.title')}</h4>
                <button onClick={closeModal}></button>
            </div>
            <div className="contact-modal__body">
                <section className="contact-modal__company-name">
                    <h4>{translate('code.products.modal.company.name')}</h4>
                    <p>{branch.name}</p>
                </section>
                <section className="contact-modal__company-contact">
                    <div className="contact-modal__contact-info">
                        <h4>{translate('code.products.modal.company.phone')}</h4>
                        <p><a href={`tel:${branch.phone}`}>{branch.phone}</a></p>
                    </div>
                    <div className="contact-modal__contact-info">
                        <h4>{translate('code.products.modal.company.email')}</h4>
                        <p><a href={`mailto:${branch.email}`}>{branch.email}</a></p>
                    </div>
                </section>
            </div>
        </dialog>
    );
};

export default ContactUsModal;
